import { css } from 'react-emotion'

const styles = {
  wrapper: css({
    background: 'rgb(250, 250, 255)',
    boxShadow: '0 8px 8px 8px rgba(255, 255, 255, 0.6) inset',
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/ReviewStyles.js